import { IFormField, IFormFieldRenderer, getFractionDigits } from '@migrate/utils/form/form'
import renderCurrency from '@migrate/utils/renderer/Currency'

export class CurrencyRenderer implements IFormFieldRenderer {
  render(field: IFormField) {
    let unit = ''
    if (field.meta.unit) {
      unit = ` ${field.meta.unit}`
    }
    // FIXME: `value` should either be a string or number here, this should be fixed with polymorphic assumption fields.
    return renderCurrency(field.value, getFractionDigits(field), field.meta.value2, unit)
  }
}
